import React from "react";
import loadable from "@loadable/component";

const Header = loadable(() =>
	import("@components/Dashboard/Pro/Funnel/Shared/Header")
);

export default ({ children, ...props }) => (
	<React.Fragment>
		<Header label={"Get started"} {...props} />
		{children}
	</React.Fragment>
);
